import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

interface ProPlanGateProps {
  hasAccess: boolean;
  loading?: boolean;
  children: React.ReactNode;
}

export const ProPlanGate: React.FC<ProPlanGateProps> = ({ hasAccess, loading, children }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!hasAccess) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ py: 8, color: 'text.secondary' }}
      >
        <LockOutlinedIcon sx={{ fontSize: 48, mb: 2, color: 'text.disabled' }} />
        <Typography variant="h6" gutterBottom>
          Цей розділ недоступний у вашій поточній підписці
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Зверніться до адміністратора для зміни тарифного плану.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};
